export default __webpack_public_path__ + "static/media/pH探头.ec95a7ee.jpg";